
import InputRadioButton from '@/components/elements/InputRadioButton.vue'
import Button from '@/components/elements/Button.vue'
import { computed, reactive, SetupContext } from 'vue'
import { axiosSetting } from '@/utils/axiosSetting'

const axios = axiosSetting('app', 'action')
export default {
  name: 'MasterQuestion',
  props: {
    answers: Array,
    images: Array,
    questionId: Number,
    questionType: Number
  },
  emits: ['submit'],
  components: {
    Button,
    InputRadioButton
  },
  setup(props: any, context: SetupContext) {
    const state = reactive<any>({
      selectedIndex: null
    })
    const selectValue = computed(() => props.answers[state.selectedIndex])
    const submitAnswer = () => {
      context.emit('submit', selectValue.value)
      console.log({
        question_id: props.questionId,
        question_type: props.questionType,
        result: selectValue.value.right_flag,
        select_value: selectValue.value.answer
      })
      axios
        .post('/api/v1/dialogue_entry', {
          question_id: props.questionId,
          question_type: props.questionType,
          result: selectValue.value.right_flag,
          select_value: selectValue.value.answer
        })
        .then((res) => console.log(res))
        .catch((e) => console.log(e))
    }
    const selectIndex = (e: any) => {
      state.selectedIndex = e
    }
    return {
      state,
      selectIndex,
      submitAnswer
    }
  }
}
